import NavBar from '../home/components/NavBar';
import PricingSection from '../home/components/PricingSection';
import IntroducerSection from '../home/components/IntroducerSection';
import RegisterSection from '../home/components/RegisterSection';
import Footer from '../home/components/Footer';

export default function PricingPage() {
  return (
    <main className="min-h-screen bg-[#EFEBE5]">
      <NavBar />
      <div className="pt-16">
        <PricingSection />
        <IntroducerSection />
        <RegisterSection />
      </div>
      <Footer />
    </main>
  );
}
